const RELOAD_AT_KEY = 'missing-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 10_000;

let backgroundLoads = 0;

export function reloadOnMissingChunk() {
    window.addEventListener('vite:preloadError', (event) => {
        // A prefetch that misses is not worth a reload: nothing on screen needs that chunk,
        // and the reload would throw away whatever the user is in the middle of typing.
        if (backgroundLoads > 0) return;

        const lastReload = Number(sessionStorage.getItem(RELOAD_AT_KEY) ?? 0);
        if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;

        event.preventDefault();
        sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
        window.location.reload();
    });
}

// Vite dispatches vite:preloadError from inside its own preload helper, before the caller's
// catch can run, so rejecting quietly is not enough to mark a load as background — the
// counter is what the listener above reads.
export function loadChunkInBackground(load: () => Promise<unknown>): Promise<void> {
    backgroundLoads += 1;
    const release = () => {
        backgroundLoads -= 1;
    };
    // The miss is swallowed on purpose: the listener above decides what to do about it, and
    // the caller has nothing to act on for a chunk it only wanted to warm.
    return load().then(release, release);
}
